"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSeeMembership = exports.isTeamLeader = exports.isPartOfTeam = void 0;
const ramda_1 = require("ramda");
const types_1 = require("../typings/types");
const Maybe_1 = require("./Maybe");
const Member_1 = require("./Member");
const Util_1 = require("./Util");
const isPartOfTeam = (member) => {
    const checker = Member_1.areMembersTheSame(member);
    const leaderChecker = ramda_1.pipe(Maybe_1.Maybe.map(checker), Maybe_1.Maybe.orSome(false));
    return (team) => leaderChecker(team.seniorCoach) ||
        leaderChecker(team.seniorMentor) ||
        leaderChecker(team.cadetLeader) ||
        team.members
            .map(Util_1.get('reference'))
            .some(Member_1.areMembersTheSame(member));
};
exports.isPartOfTeam = isPartOfTeam;
const isTeamLeader = (member) => {
    const checker = Member_1.areMembersTheSame(member);
    const leaderChecker = ramda_1.pipe(Maybe_1.Maybe.map(checker), Maybe_1.Maybe.orSome(false));
    return (team) => leaderChecker(team.cadetLeader) ||
        leaderChecker(team.seniorCoach) ||
        leaderChecker(team.seniorMentor);
};
exports.isTeamLeader = isTeamLeader;
const canSeeMembership = (member) => {
    const isPartOfTeamChecker = (team) => ramda_1.pipe(Maybe_1.Maybe.map(exports.isPartOfTeam), Maybe_1.Maybe.map(Util_1.call(team)), Maybe_1.Maybe.orSome(false))(member);
    return (team) => team.visibility === types_1.TeamPublicity.PRIVATE
        ? isPartOfTeamChecker(team)
        : team.visibility === types_1.TeamPublicity.PROTECTED
            ? member.hasValue
            : true;
};
exports.canSeeMembership = canSeeMembership;
//# sourceMappingURL=Team.js.map